<script setup lang="ts">
  import { computed } from "vue";
  import { storeToRefs } from "pinia";
  import { Tag } from "lucide-vue-next";
  import { useMAssetLibraryStore } from "@stores/mAssetLibrary";

  const assetLibraryStore = useMAssetLibraryStore();
  const { allAssetTags, activeTagFilters, isLoadingTags, campaignToken } = storeToRefs(assetLibraryStore);
  const { toggleTagFilter, clearTagFilters } = assetLibraryStore;

  const totalImagesCount = computed(() =>
    allAssetTags.value.reduce((acc, tag) => Math.max(acc, tag.images_count ?? 0), 0),
  );
</script>

<template>
  <aside class="flex flex-col overflow-hidden">
    <div class="px-4 py-3">
      <div class="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Tags</div>
      <p
        v-if="campaignToken"
        class="mt-0.5 text-2xs text-foreground-subtle">
        Most relevant to this campaign's survey first
      </p>
    </div>
    <ul class="flex-1 overflow-y-auto px-2 pb-4">
      <li>
        <button
          type="button"
          class="flex w-full items-center justify-between rounded-md px-3 py-2 text-sm hover:bg-accent"
          :class="{ 'bg-accent font-medium': activeTagFilters.length === 0 }"
          @click="clearTagFilters">
          <span>All images</span>
          <span class="text-xs text-muted-foreground">{{ totalImagesCount }}</span>
        </button>
      </li>
      <li
        v-for="tag in allAssetTags"
        :key="tag.id">
        <button
          type="button"
          class="flex w-full items-center justify-between gap-2 rounded-md px-3 py-2 text-sm hover:bg-accent"
          :class="{ 'bg-accent font-medium': activeTagFilters.includes(tag.name) }"
          @click="toggleTagFilter(tag.name)">
          <span class="flex min-w-0 items-center gap-2">
            <Tag class="h-4 w-4 shrink-0 text-muted-foreground" />
            <span class="truncate">{{ tag.name }}</span>
          </span>
          <span class="text-xs text-muted-foreground">{{ tag.images_count ?? 0 }}</span>
        </button>
      </li>
      <li
        v-if="!allAssetTags.length && !isLoadingTags"
        class="px-3 py-4 text-xs text-muted-foreground">
        No tags yet
      </li>
    </ul>
  </aside>
</template>
